import * as React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import KenIcon from '../../../KenIcon';
import DoneIcon from '../../../../Assets/Icons/tickInCircle.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useContext, useState } from 'react';
import {
  createUpdateApplication,
  getTransactionDetailsByTransactionId,
  postAppliedCouponCode,
} from '../../../../Utils/apiServices';
import { AuthContext } from '../../../../Context/authContext';

export default function ThankYouPage(props) {
  const {
    icon,
    title = 'Contact Created Successfully',
    description = "Your Contact has been successfully recorderd. We'll be in touch with you soon.",
    wrapperClassName,
    titleClass,
    subTitleClass,
    redirection = true,
  } = props;

  const { state: { user } } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [titleReceived, setTitleReceived] = useState();
  const [descriptionReceived, setDescriptionReceived] = useState();

  const query = new URLSearchParams(useLocation().search);
  const applicationId = query.get('applicationId');
  const coupon = query.get('couponId');
  const transactionId = query.get('transactionId');
  const remainingAmount = query.get('remaining');
  const name = query.get('name');

  useEffect(() => {
    if (transactionId !== null) {
      getTransactionDetailsByTransactionId(transactionId).then((res) => {
        console.log("thank you page res", res);
        if (res?.data?.status === 'Success' && coupon) {
          postAppliedCouponCode({
            couponCodeData: [
              {
                Contact: user?.applicantId,
                Application: applicationId,
                CouponCode: coupon,
              },
            ],
          }).catch(console.log);
        }
        if (res?.data?.status === 'Success' && Number(remainingAmount) === 0) {
          createUpdateApplication({
            applicationId: applicationId,
            application: {
              CurrentStepName: `${name} paid`,
              applicantId: user?.applicantId,
              recordId: applicationId,
            },
          }).catch(console.log);
        }
      });
    }
  }, [transactionId]);

  useEffect(() => {
    if (location?.state?.title && location?.state?.description) {
      setTitleReceived(location?.state?.title);
      setDescriptionReceived(location?.state?.description);
    }
  }, [location?.state]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"  // full screen vertical center
      textAlign="center"
      className={wrapperClassName}
      px={2}             // padding for small screens
    >
      <Box>
        <KenIcon iconType="img" icon={DoneIcon} />

        <Box mt={3} mb={5}>
          <Typography variant="h4" fontWeight={500} className={titleClass}>
            {titleReceived || title}
          </Typography>
        </Box>

        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="subtitle3" fontWeight={400} className={subTitleClass}>
              {descriptionReceived || description}
            </Typography>
          </Grid>

          {redirection && (
            <Grid item>
              <Typography
                variant="subtitle3"
                fontWeight={400}
                fontSize="17px"
                className={subTitleClass}
              >
                Click here to redirect on{' '}
                <span
                  onClick={() => navigate('/home')}
                  style={{ color: '#0000EE', cursor: 'pointer' }}
                >
                  Homepage
                </span>
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
